module.exports = __webpack_public_path__ + "img/MED_VEGETABLE_OILS@300x.8f025ad8.png";